import React, { useState, useEffect } from "react";
import { useIntl, defineMessages } from "react-intl";
import { connect } from "react-redux";
import DuplicateWOWarningPopup from "./duplicateTruckRollWarningPopup";
import { useHistory, useParams } from "react-router-dom";
import moment from "moment";
import { bindActionCreators } from "redux";
import { saveFollowUps, requestFollowUpDueDate } from "../../redux/followUps/followUpsActions";
import { fetchWorkorder } from "../../redux/task/taskActions";
import WorkOrderAction from "./workOrderAction";
import FormSection from "./formSection";
import FormField from "./formFields";
import FollowUpsFormField from "./followUpsField";
import { TextField, CircularProgress, Modal } from "@material-ui/core";
import { useFormStyles } from "./formFields";
import EditIcon from "../common/icons/editIcon";
import FormSelect from "./formSelect";
import { makeStyles } from "@material-ui/core/styles";
import DateTimePicker from "./../common/datepicker/dateTimePicker";

const messages = defineMessages({
    taskFollowUpHeaderTitle: {
        id: "work-order-actions.createfollowup-header",
        defaultMessage: "Create Follow-up",
        description: "Complete task form title",
    },
    Followups: {
        id: "wo-actions.follow-ups.title",
        defaultMessage: "Follow-Up",
        description: "Follow-ups popup title",
    },
    completeDate: {
        id: "task-complete-form.date-label",
        defaultMessage: "Date",
        description: "Date label",
    },
    doneButtonText: {
        id: "wo-actions.edit-popup.done",
        defaultMessage: "Done",
        description: "Done Button label",
    },
    followupReasonHeader: {
        id: "admin.work-order-details.follow-up-list.reason-col-header",
        defaultMessage: "Follow-up reason",
        description: "Admin work order follow-up reason column header",
    },
    followupCommentHeader: {
        id: "admin.work-order-details.wo-info.comments-title",
        defaultMessage: "Comments",
        description: "Admin work order follow-up comment column header",
    },
    addYourComments: {
        id: "task-incomplete-form.add-your-comments",
        defaultMessage: "Add your comments here",
        description: "Add your comments here caption",
    },
    addYourDueDate: {
        id: "admin.work-order-details.follow-up-list.due-date-col-header",
        defaultMessage: "Due Date",
        description: "Enter your Due Date here caption",
    },
});

export const followUpUseStyles = makeStyles((theme) => ({
    formResult: {
        padding: "13px 0px",
    },
    formActionBtns: {
        margin: "auto 0 auto",
        display: "flex",
        padding: 0,
    },
    formDelete: {
        marginTop: "8px",
    },
    formEdit: {
        paddingLeft: "5px",
        margin: "auto",
    },
    followUpReason: {
        fontWeight: "bold",
    },
    followUpSubreason: {
        padding: "3px 0px 2px 0px",
    },
    folowUpComment: {
        color: "#999999",
    },
    followUpHeading: {
        width: "5863px",
        height: "2665px",
        background: "#DBEBF4",
    },
    followUpUlPart: {
        border: "1px solid red",
    },
}));

export const TaskfollowUp = (props) => {
    let moment = require("moment-business-days");
    moment.updateLocale("us", { workingWeekdays: [1, 2, 3, 4, 5] });
    const { workOrderNumber } = useParams();
    const intl = useIntl();
    const history = useHistory();
    const classes = Object.assign(followUpUseStyles(), useFormStyles());
    const [deletedFollowUpIds, setDeletedFollowUpIds] = useState([]);
    const [newRowCount, setNewRowCount] = useState(0);
    const [error, setError] = useState(false);
    const [submitting, setSubmitting] = React.useState(false);
    const [openDuplicatePopup, setOpenDuplicatePopup] = useState(false);
    const woFollowUpList =
        props.workorderData && props.workorderData.followUps && props.workorderData.followUps.results ? props.workorderData.followUps.results : [];
    const [data, setData] = React.useState({
        date: new Date(),
        additionalComments: null,
        FirstfollowupReason: null,
        dueDate: null,
        followUp: {},
        comments: "",
    });

    useEffect(() => {
        if (data && data?.FirstfollowupReason) {
            duplicateWOCheck(data);
        }
    }, [data]);

    const [commentsValue, setCommentsValue] = React.useState("");
    const [dueDate, updateDueDate] = React.useState("");
    const [selectedReason, setSelectedReason] = React.useState("");
    const reasons = props.reasons;

    const handleReasonChange = (reason) => {
        setSelectedReason(reason);
    };

    const [followUpList, setFollowUpList] = useState(woFollowUpList);
    useEffect(() => {
        props.fetchWorkorder(workOrderNumber);
        props.requestFollowUpDueDate(workOrderNumber);
    }, [workOrderNumber]);

    // rebuild the local mutable copy of the followUp list
    useEffect(() => {
        if (woFollowUpList.length > 0) {
            setFollowUpList(woFollowUpList.map((w) => Object.assign({}, w))); // Deep copy
        }
    }, [woFollowUpList, props.lang]);

    useEffect(() => {
        if (data && data?.FirstfollowupReason) {
            duplicateWOCheck(data);
        }
    }, [data]);

    useEffect(() => {
        if (submitting) {
            if (!props.saveFollowUps) {
                setSubmitting(false);
            } else {
                history.push("/");
            }
            //delete
            //setSubmitting(false);
            return;
        }
    }, [props.saveFollowUps]);
    useEffect(() => {
        let duplicateWoList = props.followUpResponse?.body?.createdFollowUpList[0]?.duplicateWorkOrdersDTO?.duplicateWorkOrderDTOList;
        if (!!duplicateWoList && duplicateWoList.length > 0) {
            setOpenDuplicatePopup(true);
        }
    }, [props.followUpResponse?.body?.createdFollowUpList[0]?.duplicateWorkOrdersDTO]);

    const addFollowUp = () => {
        setFollowUpList([
            ...followUpList,
            {
                id: null,
                followUpTpyeId: null,
                comments: "",
                creationDate: moment.now(),
                dueDate: null,
                new: true,
            },
        ]);

        setNewRowCount(newRowCount + 1);
        setError(false);
    };

    const removeFollowUp = (followUp, index) => {
        const deletedFollowUp = followUpList.splice(index, 1);
        if (!followUp.new) {
            deletedFollowUpIds.push(deletedFollowUp[0].id);
        }
        setFollowUpList([...followUpList]);
    };

    const onClose = () => {
        // throw away any changes
        setFollowUpList(woFollowUpList.map((w) => Object.assign({}, w))); // Deep copy

        // clear list of deleted followUps
        setDeletedFollowUpIds([]);
        //props.onClose()
    };

    const formateDate = (iDate) => (iDate ? moment(moment(iDate)).utc().format("YYYY-MM-DD HH:mm:00") : null);
    const handleDateChange = (value) => {
        props.setNewDueDateError(!value);
    };
    const duplicateWOCheck = (data) => {
        var id = data.FirstfollowupReason.followUpTypeID;
        var reason = data.FirstfollowupReason;
        var comments = data.FirstlabourerComments;
        var dueDate = data.dueDate;
        const newFollowUp = { id, comments, creationDate: moment(Date.now()).format("YYYY-MM-DD HH:mm:ss"), dueDate: formateDate(dueDate) };
        newFollowUp.new = true;
        var finalList = null;
        var followUpInfo;
        if (data.followUps) {
            let additionalFollowUps = [...data.followUps];
            additionalFollowUps.map((followup, index) => {
                if (data[`followUps.${index}.comments`]) {
                    followup.comments = data[`followUps.${index}.comments`];
                }
                return followup;
            });
            finalList = [...data.followUps, newFollowUp];
        } else {
            finalList = [newFollowUp];
        }
        if (reason.newWorkOrderRequired) {
            followUpInfo = {
                userProfile: {
                    sub: props.userInfo.sub,
                    email_verified: props.userInfo.email_verified,
                    adGroup: ["/CmisLabourer"],
                    name: props.userInfo.name,
                    preferred_username: props.userInfo.preferred_username,
                    given_name: props.userInfo.given_name,
                    family_name: props.userInfo.family_name,
                    employeeNumber: props.technicianInfo.pein,
                },
                relatedID: workOrderNumber,
                followUpList: finalList
                    .filter((followUp) => followUp)
                    .map((followUp) => {
                        return {
                            id: null,
                            followUpTpyeId: followUp.followUpTpyeId == null ? followUp.id : followUp.followUpTpyeId,
                            creationDate: formateDate(new Date()),
                            comments: followUp.comments ? followUp.comments : null,
                            dueDate: followUp.dueDate,
                            new: followUp.new,
                            validatedForDoubles: false,
                            duplicateWorkOrdersDTO: null,
                            taskID: props.workorderData.id,
                        };
                    }),
                deletedFollowUps: deletedFollowUpIds,
            };

            props.saveFollowUps(followUpInfo, workOrderNumber);
        }
    };
    const onSave = (reason) => {
        setSubmitting(true);
        var id = data.FirstfollowupReason.followUpTypeID;
        var comments = data.FirstlabourerComments;
        var dueDate = data.dueDate;
        const newFollowUp = { id, comments, creationDate: moment(Date.now()).format("YYYY-MM-DD HH:mm:ss"), dueDate };
        newFollowUp.new = true;
        newFollowUp.isFollowUpActive = true;
        newFollowUp.duplicateWorkOrdersDTO = data.followUps[0].duplicateWorkOrdersDTO;
        var finalList = null;
        var followUpInfo;
        if (data.followUps) {
            let additionalFollowUps = [...data.followUps];
            additionalFollowUps.map((followup, index) => {
                if (data[`followUps.${index}.comments`]) {
                    followup.comments = data[`followUps.${index}.comments`];
                }
                return followup;
            });
            if (data.followUps.length > 0) {
                data.followUps.push(newFollowUp);
                finalList = data.followUps;
            }
        } else {
            finalList = [newFollowUp];
        }
        followUpInfo = {
            userProfile: {
                sub: props.userInfo.sub,
                email_verified: props.userInfo.email_verified,
                adGroup: ["/CmisLabourer"],
                name: props.userInfo.name,
                preferred_username: props.userInfo.preferred_username,
                given_name: props.userInfo.given_name,
                family_name: props.userInfo.family_name,
                employeeNumber: props.technicianInfo.pein,
            },
            relatedID: workOrderNumber,
            followUpList: finalList
                .filter((followUp) => followUp.new)
                .map((followUp) => {
                    return {
                        id: null,
                        followUpTpyeId: followUp.followUpTpyeId == null ? followUp.id : followUp.followUpTpyeId,
                        creationDate: formateDate(new Date()),
                        comments: followUp.comments ? followUp.comments : null,
                        dueDate: followUp.dueDate,
                        new: followUp.new,
                        validatedForDoubles: followUp.new ? true : false,
                        taskID: props.workorderData.id,
                        duplicateWorkOrdersDTO: data.followUps?.[0].duplicateWorkOrdersDTO ? data.followUps[0].duplicateWorkOrdersDTO : null,
                    };
                }),
            deletedFollowUps: deletedFollowUpIds,
        };

        props.saveFollowUps(followUpInfo, workOrderNumber);
        history.push(`/workorderdetails/${workOrderNumber}`);

        // clear list of deleted followUps
        setDeletedFollowUpIds([]);

        setSubmitting(false);
        // Clear error
        setError(false);
    };
    return (
        <>
            {props.followUpsResponse?.body?.createdFollowUpList[0]?.duplicateWorkOrdersDTO && (
                <DuplicateWOWarningPopup
                    open={openDuplicatePopup}
                    setOpen={setOpenDuplicatePopup}
                    followUpsResponse={props.followUpsResponse}
                    keycloak={props.keycloak}
                />
            )}
            <WorkOrderAction title={intl.formatMessage(messages.taskFollowUpHeaderTitle)} followUps onSubmit={onSave} data={data}>
                <Modal style={{ display: "flex", alignItems: "center", justifyContent: "center" }} open={submitting}>
                    <CircularProgress />
                </Modal>
                <FormSection className={classes.followUpUlPart} title={intl.formatMessage(messages.Followups)}>
                    <FormField field="date" label={intl.formatMessage(messages.completeDate)} readonly />
                    <FormField
                        field="FirstfollowupReason"
                        label={intl.formatMessage(messages.followupReasonHeader)}
                        required
                        editorProps={{
                            icon: <EditIcon />,
                            title: intl.formatMessage(messages.followupReasonHeader),
                            btnText: intl.formatMessage(messages.doneButtonText),
                            duplicateWOCheck: duplicateWOCheck,
                            setData: setData,
                            data: data,
                            dueDate: props.dueDate,
                            selectedReason: selectedReason,
                            editor: (props) => (
                                <FormSelect
                                    options={reasons}
                                    onSelect={(reason) => handleReasonChange(reason)}
                                    existingValue={!!data?.reason ? data.reason : null}
                                    {...props}
                                />
                            ),
                        }}
                    />
                    <FormField field="dueDate" label={intl.formatMessage(messages.addYourDueDate)} required />
                    <FormField
                        field="FirstlabourerComments"
                        label={intl.formatMessage(messages.followupCommentHeader)}
                        editorProps={{
                            icon: <EditIcon />,
                            title: intl.formatMessage(messages.followupCommentHeader),
                            btnText: intl.formatMessage(messages.doneButtonText),
                            editor: (props) => (
                                <TextField
                                    value={data.comments}
                                    id="labourer-comments"
                                    placeholder={intl.formatMessage(messages.addYourComments)}
                                    multiline
                                    fullWidth
                                    rows={4}
                                    variant="outlined"
                                    InputProps={{
                                        inputProps: { maxLength: 300 },
                                    }}
                                    onChange={(e) => setCommentsValue(e.target.value)}
                                    {...props}
                                />
                            ),
                        }}
                        characterCountEnabled
                    />
                    <FollowUpsFormField
                        field="followUps"
                        duplicateWOCheck={duplicateWOCheck}
                        workOrderFollowUp={true}
                        workorderData={props.workorderData}
                        openDuplicatePopup={openDuplicatePopup}
                        setOpenDuplicatePopup={setOpenDuplicatePopup}
                        workOrderNumber={workOrderNumber}
                        reasons={props.reasons}
                        data={data}
                        dueDate={props.dueDate}
                        setData={setData}
                        selectedReason={selectedReason}
                    />
                </FormSection>
            </WorkOrderAction>
        </>
    );
};

const mapStateToProps = (state) => ({
    lang: state.domain.locale.lang,
    keycloak: state.login.keycloak,
    reasons: state.followUps.followUpReasons ? state.followUps.followUpReasons : [],
    FirstfollowupReason: state.followUps.FirstfollowupReason,
    followUpsResponse: state.followUps.followUpsResponse,
    userProfile: state.login.userProfile,
    userInfo: state.login.userInfo,
    technicianInfo: state.login.technicianInfo,
    dueDate: state.followUps.dueDate,
    workorderData: state.tasks.workorderData.workorderData,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchWorkorder,
            saveFollowUps,
            requestFollowUpDueDate,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(TaskfollowUp);
